// extracted by mini-css-extract-plugin
export default {"container":"Video_container__FkK0l","title":"Video_title__aHyUj","inner":"Video_inner__BEk-Q","video":"Video_video__9psOt"};